function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogoCsharp = function SvgLogoCsharp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00000"
    },
    r: 30,
    cy: 32,
    cx: 32,
    className: "logo-csharp_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M30.43 43.55a14.78 14.78 0 0 1-7 1.48 11.23 11.23 0 0 1-8.61-3.46 12.78 12.78 0 0 1-3.23-9.09 13.39 13.39 0 0 1 3.64-9.77A12.35 12.35 0 0 1 24.49 19a14.8 14.8 0 0 1 5.94 1v3.15a12 12 0 0 0-6-1.51 9.17 9.17 0 0 0-7 2.9 10.93 10.93 0 0 0-2.7 7.75 10.4 10.4 0 0 0 2.52 7.34 8.58 8.58 0 0 0 6.62 2.73 12.42 12.42 0 0 0 6.57-1.69ZM52.76 26.46l-.4 1.86h-4.6l-1.1 5.28h4.94l-.47 1.86h-4.84l-1.55 7h-2.21l1.51-7h-4.4l-1.48 7H36l1.48-7h-4.64l.35-1.86h4.66l1.07-5.27h-4.87l.37-1.86h4.87l1.48-7.07H43l-1.48 7.07h4.43l1.51-7.07h2.16l-1.48 7.07Zm-7.17 1.86h-4.44L40 33.6h4.46Z",
    className: "logo-csharp_svg__cls-3"
  }));
};

export default SvgLogoCsharp;